module.exports = __webpack_public_path__ + "static/media/vulture-white.365dfe3d.png";